@if (attachment != null) {
  <button mat-raised-button [title]="attachment.fileName" style="margin-right: 5px"
    [disabled]="loading" (click)="download()">
    @if (!loading) {
      <div class="filename">
        <span class="name">{{name}}</span><span class="extension">{{extension}}</span>
      </div>
    }
    @if (loading) {
      <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
    }
  </button>
}